// extracted by mini-css-extract-plugin
module.exports = {"base":"Divider_base__1PmTv","or":"Divider_or__2-goe","text":"Divider_text__12_IJ"};